import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSearchParams, useNavigate, useSearchParams, } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Drawer from "react-bottom-drawer";
// Components
import MobStockDetails from "../StockViewInDetail/MobStockDetails";
import ProfitAndLossReport from "@frameworks/web/components/Reports/PNLReports/ProfitAndLossReport";
import TaxMainComponent from "@frameworks/web/components/Reports/TaxReports/TaxMainComponent";
import { Dashboard } from "@frameworks/web/components/Reports/Dashboard/Dashboard";
import HoldingReportComponentMobile from "./HoldingReports/HoldingReportCompnentMobile";
import OtherReports from "../OtherReports";
import { Edelweisslogo } from "@frameworks/web/utils/edelweisslogo-header";
import { fetchAccountDetails } from "@frameworks/web/redux/reducers/Reports/accountDetailsThunk";
import { JwtTokenNestThunk } from "@frameworks/web/redux/reducers/JwtTokenNestThunk";
import { ExtPlatDataRetrieveThunks } from "@frameworks/web/redux/reducers/ExtPlatDataRetrieve";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
// Utilities and Types
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
import { useParamsContext } from "@frameworks/web/components/generic/customHooks/ParamsContext";
import { ERports } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
import { ReportScrollBehaviour } from "@frameworks/web/index";
import _ from "underscore";
import { usePageVisibility } from "@frameworks/web/components/generic/customHooks/usePageVisibility";
// DI
import holdingDI from "../di/servicelocator";
import familyDi from "@frameworks/web/components/Reports/FamilyTagging/di/servicelocator";
import PNLDI from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
// Assets
import loaderGIF from "@frameworks/web/assets/images/Reports/loaderGIF.gif";
// Styles
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/HoldingReportsMobile.scss";
import "@frameworks/web/stylesheets/components/Reports/HoldingPositionMobileReport.scss";
import { REPORT_TAB_KEYS, REPORT_TAB_NAMES, ReportTabKeys } from "../constants";
import { IPNLSubTabs } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import TransactionHistoryMain from "@frameworks/web/components/Reports/TransactionHistory/TransactionHistoryMain";
import AifPdfDownloadStatus from "../AifPdfDownloadStatus";
const HoldingPositionReportMobile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tabsRef = useRef(null);
    const isVisible = usePageVisibility();
    // URL parameters
    const reportTabKey = getQueryParameterName("reportName");
    const loginToken = getQueryParameterName("jwt_token");
    const accData = decodeURIComponent(getQueryParameterName("acc_data"));
    const platform = getQueryParameterName("platform");
    const userID = getQueryParameterName("UserId");
    const exToken = getQueryParameterName("TokenId");
    const token = getQueryParameterName("token");
    // State
    const ACTIVE_KEY = ReportTabKeys.get(reportTabKey ? reportTabKey : REPORT_TAB_KEYS.Dashboard).key;
    const [loader, setLoader] = useState(false);
    const [downloadAif, setDownloadAif] = useState(false);
    const [tillDateSelectedPNL, setTillDateSelectedPNL] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [pnlKey, setPnlKey] = useState(IPNLSubTabs.ALL);
    const [searchParams, setSearchParams] = useSearchParams();
    // Selectors
    const showShimmer = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jwtTokenNestTraderReducer) === null || _a === void 0 ? void 0 : _a.showShimmer; });
    const PNLStreamFromStore = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.stream; }, _.isEqual);
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const selectedRowIndex = useSelector((state) => state.holdingReport.selectedRowIndex);
    const holdingSummary = useSelector((state) => state.dashboardSummary.holdings.summary);
    const isSummarize = useSelector((state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.IsSummarize; });
    //hooks
    const { routeParams, setRouteParams } = useParamsContext();
    // Event handlers
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    const handleTabSelect = (key) => {
        if (key === ACTIVE_KEY)
            return;
        // Special case for switching between Holding and Dashboard
        if ((ACTIVE_KEY === REPORT_TAB_KEYS.Holdings &&
            key === REPORT_TAB_KEYS.Dashboard) ||
            (ACTIVE_KEY === REPORT_TAB_KEYS.Dashboard &&
                key === REPORT_TAB_KEYS.Holdings)) {
            // Retain when switching between holding & dashboard
            familyDi.familyTagging.setStopFamilyAPICall(true);
        }
        else {
            familyDi.familyTagging.setStopFamilyAPICall(false);
            familyDi.familyTagging.setSelectedFamilyMember("", null);
        }
        // Update URL
        navigate({
            pathname: "",
            search: createSearchParams({
                reportName: key,
            }).toString(),
        });
        //handle PNL
        PNLDI.pnlReport.pnlToggleStream(false);
        // Send GTM event
        GTMService.gtmService(new ReportGAEvents(`${ReportTabKeys.get(key).title} ${ReportsGTMConstants.Report}`, ReportsGTMConstants.NewReports, `${ReportTabKeys.get(key).title} ${ReportsGTMConstants.Report}`));
    };
    // JWT handling
    const setJwtToken = () => {
        if (loginToken !== null && (platform === "tx3" || platform === "NT")) {
            localStorage.setItem("jwt_token", loginToken !== null ? loginToken : localStorage.getItem("jwt_token"));
            localStorage.setItem("acc_data", accData !== null ? accData : localStorage.getItem("acc_data"));
        }
        if (platform === "tx3") {
            localStorage.setItem("lgnSrc", "X");
            dispatch(ExtPlatDataRetrieveThunks(token));
        }
    };
    const setJwtTokenForNestTrader = React.useCallback(() => {
        if (userID && exToken) {
            const payload = {
                userId: userID,
                extoken: exToken,
            };
            dispatch(JwtTokenNestThunk(payload));
        }
    }, [dispatch, exToken, userID]);
    // Effects
    useEffect(() => {
        setLoader(showShimmer);
    }, [showShimmer]);
    useEffect(() => {
        setJwtToken();
        setJwtTokenForNestTrader();
        dispatch(fetchAccountDetails());
        sessionStorage.setItem("initialLoad", "true");
    }, []);
    useEffect(() => {
        if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
            holdingDI.holdingReport.getHoldingReportData({
                familyAccodes: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
            });
        }
    }, [selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode]);
    useEffect(() => {
        if (tabsRef && tabsRef.current) {
            tabsRef.current.addEventListener("scroll", handleScroll);
        }
        window.addEventListener("scroll", handleScroll);
        return () => {
            if (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) {
                tabsRef.current.removeEventListener("scroll", handleScroll);
            }
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    // Effect to load saved params when report tab changes
    React.useEffect(() => {
        if (reportTabKey) {
            const savedParams = routeParams.get(reportTabKey);
            // Only set search params if we have saved params and they're different
            if (savedParams) {
                // Check if current params are different from saved params
                const currentParamsString = searchParams.toString();
                const savedParamsString = savedParams.toString();
                if (currentParamsString !== savedParamsString) {
                    setSearchParams(savedParams);
                }
            }
        }
    }, [reportTabKey]);
    React.useLayoutEffect(() => {
        if (reportTabKey === ACTIVE_KEY) {
            // Create a copy of searchParams to avoid reference issues
            const paramsCopy = new URLSearchParams(searchParams.toString());
            setRouteParams(reportTabKey, paramsCopy);
        }
    }, [reportTabKey, searchParams, ACTIVE_KEY]);
    React.useEffect(() => {
        if (PNLStreamFromStore)
            PNLDI.pnlReport.getPNLStreamData(!isVisible);
    }, [isVisible]);
    const holdingsDetails = useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.HoldingDetails; });
    const item = selectedRowIndex >= 0 ? holdingsDetails[selectedRowIndex] : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { id: "holding", ref: tabsRef },
            React.createElement("div", { className: "container mt-3", id: "holdings-heading" },
                React.createElement("div", { className: "d-flex align-items-center", id: "holding-main-heading" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(Edelweisslogo, null)))),
            loader && (React.createElement("div", { className: "img-loader loader-mob" },
                React.createElement("img", { className: "loader", src: loaderGIF, alt: "loaderGIF" }))),
            !loader && (React.createElement("div", { className: "container", id: "holdings-tabs", ref: tabsRef },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "holding-tabs" },
                        React.createElement(Tabs, { id: "holdingsmyTab", defaultActiveKey: reportTabKey || ACTIVE_KEY, activeKey: ACTIVE_KEY, onSelect: handleTabSelect, className: `pt-4 holding-tabs-scrollable ${scrollPosition > 100 ? "holding-tab-dock" : ""}` },
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.Dashboard, title: "Dashboard", id: "dashboard-tab" },
                                React.createElement("div", { id: "dashboard" }, ACTIVE_KEY === REPORT_TAB_KEYS.Dashboard &&
                                    holdingSummary && (React.createElement(Dashboard, { summary: holdingSummary, reportName: ERports.HOLDINGS, setSummary: (isSummarize) => holdingDI.holdingReport.getSummarizeHoldingReportData(isSummarize), enableSummary: isSummarize, getDashboardData: (fromDate, toDate, isFamily, accountIds) => {
                                        const payload = {
                                            isFamily: isFamily,
                                            accountIds: accountIds,
                                        };
                                        holdingDI.holdingReport.getDashboardData(payload);
                                    } })))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.Holdings, title: REPORT_TAB_NAMES.Holdings, id: "holdings-tab holdings" }, ACTIVE_KEY === REPORT_TAB_KEYS.Holdings && (React.createElement(React.Fragment, null,
                                React.createElement("div", { id: "holdings" },
                                    React.createElement(HoldingReportComponentMobile, { openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, loader: loader, setLoader: setLoader, accCodes: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode })),
                                selectedRowIndex >= 0 && openDrawer && (React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: () => setOpenDrawer(false), isVisible: openDrawer, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                                    React.createElement(MobStockDetails, { selectedRowIndex: selectedRowIndex, setOpenDrawer: setOpenDrawer, loader: loader, setLoader: setLoader, isMyaccount: (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) === myAccCode, setDownloadAif: setDownloadAif })))))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.PNL, title: REPORT_TAB_NAMES.PNL, id: "profit&loss-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.PNL && (React.createElement("div", { id: "profit&loss" },
                                React.createElement(ReportScrollBehaviour, null),
                                React.createElement(ProfitAndLossReport, { loader: loader, setLoader: setLoader, tabKey: pnlKey, setTabKey: setPnlKey, setTillDateSelected: setTillDateSelectedPNL, tillDateSelected: tillDateSelectedPNL })))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.TAX, title: REPORT_TAB_NAMES.TAX, id: "tax-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.TAX && (React.createElement("div", { id: "Tax" },
                                React.createElement(TaxMainComponent, null)))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.TRANSACTIONHISTORY, title: REPORT_TAB_KEYS.TRANSACTIONHISTORY, id: "Transactions" }, ACTIVE_KEY === REPORT_TAB_KEYS.TRANSACTIONHISTORY && (React.createElement("div", { id: "Transactions" },
                                React.createElement(TransactionHistoryMain, null)))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.OTHER, title: REPORT_TAB_NAMES.OTHER, id: "other-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.OTHER && React.createElement(OtherReports, null)))))))),
        downloadAif && (React.createElement(AifPdfDownloadStatus, { selectedData: item, setDownloadAif: setDownloadAif, downloadAif: downloadAif }))));
};
export default HoldingPositionReportMobile;
